<template>
  <q-a-card
    type="Question"
    deletable
    editable
    add
    :valid="valid"
    :items="questions"
    @get-items="getQuestions"
    @put-item="putQuestions"
    @post-item="postQuestions"
    @edit-item="editQuestions"
    @delete-item="deleteQuestions"
    @modal-close="resetForm"
  >
    <template slot="title">Questions</template>
    <template slot="subTitle"
      >Add Questions, then click to create answers</template
    >
    <template slot="dialog"
      ><v-form ref="form">
        <v-text-field v-model="question.questionText" label="Question">
        </v-text-field>
      </v-form>
      <answer-card
        v-if="editing"
        :questionId="question.questionId"
      ></answer-card>
    </template>
  </q-a-card>
  <!-- Question Component -->
</template>

<script>
import QACard from "@/components/test/QACard.vue";
import AnswerCard from "@/components/test/AnswerCard.vue";
//import AddAnswersForm from "@/components/test/AddAnswersForm.vue";
import QuestionService from "@/services/QuestionService.js";
//import AnswerService from "@/services/AnswerService.js";
export default {
  props: {
    testId: String
  },
  components: {
    QACard,
    AnswerCard
    //AddAnswersForm
  },
  data() {
    return {
      dialog: false,
      valid: "",
      loading: false,
      questions: [],
      question: {},
      editing: false
    };
  },

  methods: {
    async getQuestions() {
      this.loading = true;
      try {
        this.questions = await QuestionService.getQuestionsByTestId(
          this.testId
        );
      } finally {
        this.loading = false;
      }
    },
    putQuestions() {
      if (this.$refs.form.validate()) {
        this.question.testId = this.testId;
        QuestionService.putQuestion(this.question).then(() => {
          this.getQuestions(),
            this.$snackbarSuccess("Question Successfully Edited");
        });
      }
    },
    postQuestions() {
      if (this.$refs.form.validate()) {
        this.question.testId = this.testId;
        QuestionService.postQuestion(this.question).then(() => {
          this.getQuestions(),
            this.$snackbarSuccess("Question Successfully Added");
        });
      }
    },
    editQuestions(item) {
      this.editing = true;
      this.question = Object.assign({}, item);
    },
    deleteQuestions(item) {
      QuestionService.deleteQuestion(item.questionId).then(() => {
        this.getQuestions(), this.$snackbarSuccess("Question Deleted");
      });
    },
    resetForm() {
      // Doesn't clear everything since an edit pulls in extra fields
      // Does that matter?
      this.$refs.form.reset();
      this.editing = false;
    }
  }
};
</script>
